import apigClientFactory from 'aws-api-gateway-client'
import store from '@/store'
import cognito from '@/cognito'

export default class Apig {
  configure (config) {
    this.config = config
    this.apigClient = apigClientFactory.newClient(config)
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$apig', {
      get () { return this.$root._apig }
    })

    Vue.mixin({
      beforeCreate () {
        if (this.$options.apig) {
          this._apig = this.$options.apig
          this._apig.configure(options)
        }
      }
    })
  }

  // var pathParams = {
  //     This is where path request params go.
  //     userId: '1234',
  // };
  // // Template syntax follows url-template https://www.npmjs.com/package/url-template
  // var pathTemplate = '/users/{userID}/profile'
  // var method = 'GET';
  // var additionalParams = {
  //     //If there are query parameters or headers that need to be sent with the request you can add them here
  //     headers: {
  //         param0: '',
  //         param1: ''
  //     },
  //     queryParams: {
  //         param0: '',
  //         param1: ''
  //     }
  // };
  // var body = {
  //     //This is where you define the body of the request
  // };

  init () {
    return new Promise((resolve, reject) => {
      cognito.isAuthenticated()
        .then(credentials => {
          store.commit('onAuthStateChanged', credentials.data.Credentials)
          store.commit('onLoginStatusChanged', true)
          this.apigClient = apigClientFactory.newClient({
            region: this.config.region,
            invokeUrl: this.config.invokeUrl,
            accessKey: credentials.data.Credentials.AccessKeyId,
            secretKey: credentials.data.Credentials.SecretKey,
            sessionToken: credentials.data.Credentials.SessionToken
          })

          resolve()
        })
        .catch((err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  initNoAuth () {
    return new Promise((resolve, reject) => {
      cognito.getCredentialsNoAuth()
        .then(credentials => {
          store.commit('onAuthStateChanged', credentials.data.Credentials)
          store.commit('onLoginStatusChanged', false)
          this.apigClient = apigClientFactory.newClient({
            region: this.config.region,
            invokeUrl: this.config.invokeUrl,
            accessKey: credentials.data.Credentials.AccessKeyId,
            secretKey: credentials.data.Credentials.SecretKey,
            sessionToken: credentials.data.Credentials.SessionToken
          })

          resolve()
        })
        .catch((err) => {
          console.log(err)
          reject(err)
        })
    })
  }

  invokeApi (pathParams, pathTemplate, method, additionalParams, body) {
    return new Promise((resolve, reject) => {
      this.init()
        .then(() => {
          this.apigInvokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(data => {
              resolve(data)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  invokeApiNoAuth (pathParams, pathTemplate, method, additionalParams, body) {
    return new Promise((resolve, reject) => {
      this.initNoAuth()
        .then(() => {
          this.apigInvokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(data => {
              resolve(data)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  apigInvokeApi (pathParams, pathTemplate, method, additionalParams, body) {
    return new Promise((resolve, reject) => {
      this.apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(response => {
          resolve(response)
        }).catch(function (err) {
          console.log(err)
          reject(err)
        })
    })
  }

  get (pathTemplate, pathParams, additionalParams, body, isNoAuth) {
    if (!isNoAuth) {
      return new Promise((resolve, reject) => {
        this.invokeApi(pathParams, pathTemplate, 'GET', additionalParams, body)
          .then(function (response) {
            resolve(response)
          }).catch(function (err) {
            console.log(err)
            reject(err)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.invokeApiNoAuth(pathParams, pathTemplate, 'GET', additionalParams, body)
          .then(function (response) {
            resolve(response)
          }).catch(function (err) {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  post (pathTemplate, pathParams, additionalParams, body) {
    return new Promise((resolve, reject) => {
      this.invokeApi(pathParams, pathTemplate, 'POST', additionalParams, body)
        .then(function (response) {
          resolve(response)
        }).catch(function (err) {
          console.log(err)
          reject(err)
        })
    })
  }

  patch (pathTemplate, pathParams, additionalParams, body, isNoAuth) {
    if (!isNoAuth) {
      return new Promise((resolve, reject) => {
        this.invokeApi(pathParams, pathTemplate, 'PATCH', additionalParams, body)
          .then(function (response) {
            resolve(response)
          }).catch(function (err) {
            console.log(err)
            reject(err)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.invokeApiNoAuth(pathParams, pathTemplate, 'PATCH', additionalParams, body)
          .then(function (response) {
            resolve(response)
          }).catch(function (err) {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  getSignedURL (file, additionalParams) {
    let pathTemplate = store.getters.api.GETSIGNEDURL
    let body = {
      contentType: file.type,
      fileName: file.name
    }

    return new Promise((resolve, reject) => {
      this.invokeApi({}, pathTemplate, 'POST', additionalParams, body)
        .then((res) => {
          resolve(res || '/')
        })
        .catch((err) => {
          console.log(err)
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apig/apig.js